import { render } from "./OilList.vue?vue&type=template&id=02e8fa66&scoped=true&ts=true"
import script from "./OilList.vue?vue&type=script&lang=tsx"
export * from "./OilList.vue?vue&type=script&lang=tsx"

import "./OilList.vue?vue&type=style&index=0&id=02e8fa66&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e8fa66"]])

export default __exports__